import { rootRoute } from './root'
import { listRoute } from './list'
import { applicationRoute } from './application'

export const applicationsRoute = rootRoute.addChildren([listRoute, applicationRoute])
